import React, { useState } from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";
// import BackIcon from "@styles/all-images/icons/back-button.svg";

interface RejectionReasonProps {
  onClose: () => void;
  onSubmit: (reason: string) => void;
  isLoading?: boolean;
}

const TierConfigurationRejectionReason = ({
  onClose,
  onSubmit,
  isLoading = false,
}: RejectionReasonProps) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    if (!rejectionReason.trim()) {
      setErrorMessage(
        "Please provide a valid reason for rejecting the document",
      );
      setShowError(true);
      return;
    }
    if (rejectionReason.length > 500) {
      setErrorMessage("Rejection description cannot exceed 500 characters.");
      setShowError(true);
      return;
    }
    setShowError(false);
    setErrorMessage("");
    onSubmit(rejectionReason);
  };

  return (
    <div>
      <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
        <div className="tw-bg-white tw-rounded-2xl tw-w-[400px] tw-p-6">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
            <div></div>
            <h2 className="tw-text-base font-weight-semibold font-primary-color">
              Rejection Reason
            </h2>
            <button
              onClick={onClose}
              className="tw-text-gray-500 tw-hover:text-gray-700"
            >
              <img src={CloseIcon} alt="Close Icon" className="tw-w-5 tw-h-5" />
            </button>
          </div>

          <div className="form-group tw-mb-6">
            <p className="font-gray-color-dark font-weight-medium font-size-sm leading tw-mb-2">
              Rejection Reason
            </p>
            <textarea
              className={`tw-w-full tw-max-h-[400px] tw-border ${showError ? "tw-border-red-500" : "tw-border-gray-300"} tw-rounded-md tw-p-2`}
              placeholder="Enter a valid reason for rejection..."
              value={rejectionReason}
              onChange={(e) => {
                setRejectionReason(e.target.value);
                setShowError(false);
              }}
              rows={4}
            ></textarea>
            {showError && (
              <p className="tw-text-red-500 tw-text-sm tw-mt-1">
                {errorMessage}
              </p>
            )}
          </div>

          <div className="tw-flex tw-space-x-4">
            <button
              onClick={onClose}
              className="tw-flex-1 tw-px-4 tw-py-2 tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-w-[50%] tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TierConfigurationRejectionReason;
